<template>
	<tr class="record" @click.stop="$emit('redirect', item)">
		<td class="py-1">{{ item.matter.order_date | dateFormatter }}</td>
		<td class="py-1">{{ item.created_user.full_name }}</td>
		<td class="py-1">{{ item.created_at | dateFormatter }}</td>
		<td class="py-1">{{ item.matter.order_number }}</td>
		<td class="py-1">{{ item.source_of_base_material | sourceOfBaseMaterialFormatter }}</td>
		<td class="py-1">{{ item.arrangement_availability | arrangementAvailabilityFormatter }}</td>
		<td class="py-1">{{ item.matter.deadline | dateFormatter }}</td>
		<td class="py-1">
			<p>{{ item.matter.regular_customer_company ? item.matter.regular_customer_company.name : "" }}</p>
		</td>
		<td class="py-1">
			{{ item.matter.regular_customer_company ? item.matter.regular_customer_company.phone : "" }}
		</td>
		<td class="py-1">
			{{ item.matter.regular_customer_company ? item.matter.regular_customer_company.zipcode : "" }}
		</td>
		<td class="py-1">
			<p>
			{{ item.matter.regular_customer_company ? item.matter.regular_customer_company.address : "" }}
			</p>
		</td>
		<td class="py-1">
			<p>
			{{ item.matter.regular_customer_company ? item.matter.regular_customer_company.prefecture : "" }}
			</p>
		</td>
		<td class="py-1">
			<p>
			{{
				item.matter.regular_customer_company ? item.matter.regular_customer_company.city : ""
			}}
			</p>
		</td>
		<td class="py-1">
			<p>
			{{
				item.matter.regular_customer_company ? item.matter.regular_customer_company.building : ""
			}}
			</p>
		</td>
		<td class="py-1">
			<p>
			{{ item.matter.customer_company ? item.matter.customer_company.name : "" }}
			</p>
		</td>
		<td class="py-1">{{ item.matter.customer_person ? item.matter.customer_person.name : "" }}</td>
		<td class="py-1">
			<p>
			{{ item.matter.plant_customer_company ? item.matter.plant_customer_company.name : "" }}
			</p>
		</td>
		<td class="py-1">
			{{item.approval_status | approvalFormatter}}
		</td>
	</tr>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	filters: {
		dateFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD")
			}
		},
		sourceOfBaseMaterialFormatter(item) {
			switch (item) {
				case "free":
					return "無償支給"
					break
				case "own":
					return "KG手配"
					break
			}
		},
		arrangementAvailabilityFormatter(item) {
			switch (item) {
				case true:
					return "可"
					break
				case false:
					return "否"
					break
			}
		},
		approvalFormatter(item) {
			switch (item) {
				case "yet":
					return "未承認"
					break
				case "approved":
					return "承認済み"
					break
				case "reject":
					return "非承認"
					break
			}
		},
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		authorized: {
			type: Boolean,
			default: false,
			required: false,
		},
	},

	data() {
		return {}
	},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
}
p {
	white-space: pre-wrap;
}

.record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.matter-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
